app.controller('signinController', function ($scope,$auth,$state,$location,objectService,questionService) {
    var query = $location.search();

    $scope.token = query.token;

    if(query.review){
        objectService.setReviewMode(true);
    }

    if(query.token){
        // Use Satellizer's $auth service to login
        $auth.login({token: query.token}).then(function(data) {
            $state.go('start');
        });
    }
});
